import React from 'react'
import DesignNavbar from './DesignNavbar'
import DesignFooter from './DesignFooter'
import SectionSearchResultList from './SectionSearchResultList'
import SectionSearchResultLocationAndDate from './SectionSearchResultLocationAndDate'

const DesignSearchResult = () => {
    return (
        <div style={{ position: "relative" }}>

            <DesignNavbar />

            {/*Section des filtre */}
            <SectionSearchResultLocationAndDate />

            {/*Section de Filtre et item de elements */}
            
            <SectionSearchResultList />

            <DesignFooter />

        </div>
    )
}

export default DesignSearchResult